module.exports = __webpack_public_path__ + "static-appopensalud/img/openlegalpro_blue.78122e0.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openlegalpro_blue.svg
// module id = 1032
// module chunks = 117